import fr from '../translations/fr.json';
import it from '../translations/it.json';

const changePercentageToBracketsInterpolation = (jsonContent) => {
  function replacePercents(str: string) {
    return str.replace(/%\D\w+%/g, (match) => {
      return match.replace('%', '{').replace('%', '}');
    });
  }

  function processObject(obj) {
    for (const key in obj) {
      if (typeof obj[key] === 'string') {
        obj[key] = replacePercents(obj[key]);
      } else if (typeof obj[key] === 'object') {
        processObject(obj[key]);
      }
    }
  }

  processObject(jsonContent);
  return (jsonContent)
}

export default defineI18nConfig(() => ({
  legacy: false,
  messages: {
    fr: changePercentageToBracketsInterpolation(fr),
    it: changePercentageToBracketsInterpolation(it)
  },
}))
